import Step2Icon from "../assets/console/step2Icon.svg";
import Step3Icon from "../assets/console/step3Icon.svg";

import FirstFrameStep1Icon from "../assets/console/firstFrameStep1Icon.svg";
import SecondFrameStep1Icon from "../assets/console/secondFrameStep1Icon.svg";
import ThirdFrameStep1Icon from "../assets/console/thirdFrameStep1Icon.svg";
import FourthFrameStep1Icon from "../assets/console/fourthFrameStep1Icon.svg";
import FifthFrameStep1Icon from "../assets/console/fifthFrameStep1Icon.svg";

export const OTHER_CONTROLLERS_FAQ_URL =
  "https://help.onmoplus.com/en/collections/19687520-controller";

export const CONTROLLER_PAIRING_STEPS = [
  {
    key: "step1",
    titleKey: "Controller_Step 1 : Select Wireless Mode",
    descKey:
      "Controller_Hold the M (Mode) button for 1 second to switch modes. Repeat until the desired LED lights up.",
    image: null,
  },
  {
    key: "step2",
    titleKey: "Controller_Step 2 : Start Pairing Mode",
    descKey:
      "Controller_Hold the PAIR button for 3 seconds until the LED flashes rapidly.",
    image: Step2Icon,
  },
  {
    key: "step3",
    titleKey: "Controller_Step 3 : Select Controller",
    descKey:
      "Controller_Select the correct controller name from your device’s Bluetooth settings. When connected, the LED turns solid and the controller vibrates once.",
    image: Step3Icon,
  },
];

export const STEP1_FRAMES = [
  FirstFrameStep1Icon,
  SecondFrameStep1Icon,
  ThirdFrameStep1Icon,
  FourthFrameStep1Icon,
  FifthFrameStep1Icon,
  FirstFrameStep1Icon,
];

export const FRAME_INTERVAL_MS = 2000;
export const FRAME_REST_MS = 6000;
